export default {
    my_domains: 'ដែន',
    my_invoices: 'វិក្ក័យប័ត្រ',
    my_cloud_hosting: 'ប្រព័ន្ធផ្ទុកពពក',
    my_shared_hosting: 'ចែករំលែកប្រពន្ធផ្ទុក',
    my_cloud_server: 'Cloud Server',
    my_transactions: 'ប្រតិបត្តិការ',
    expired_date: 'កាលបរិច្ឆេទ​ផុត​កំណត់',
    dashboard: 'ផ្ទាំងគ្រប់គ្រង',
    welcome:
        '<span class="text-primary">សូមស្វាគមន៍</span> មកកាន់ផ្ទាំងគ្រប់គ្រងអតិថិជន 1Byte របស់អ្នក!',
    service: 'សេវាកម្មរបស់អ្នកនៅ <span class="text-primary">1Byte</span>',
    service_subtitle: 'គ្រប់គ្រងសេវាកម្មរបស់អ្នកបានរហ័ស និងងាយស្រួលជាមួយយើង!',
    total_domains: 'ដែនសរុប',
    total_cloud_hosting: 'Cloud Hosting សរុប',
    total_cloud_server: 'Cloud Server សរុប',
    total_shared_hosting: 'Shared Hosting សរុប',
    total_wordpress_hosting: 'WordPress hosting សរុប',
    total_ssl: 'វិញ្ញាបនបត្រ SSL សរុប',
};
